export default __webpack_public_path__ + "static/media/insight.10947e9a.svg";